import { Logo } from "@/components/brand/Logo";

interface Props {
  className?: string;
  /** Wrap in <Link to="/">. Defaults to true. */
  asLink?: boolean;
}

/**
 * Backward-compat wrapper. Prefer importing `<Logo />` directly from
 * `@/components/brand/Logo`. This shim exists so older imports keep working.
 */
export function BrandLogo({ className = "w-24 sm:w-28 h-auto", asLink = true }: Props) {
  return <Logo className={className} asLink={asLink} />;
}
